import api from './api'

export interface SMTPAccount {
    id: number
    name: string
    host: string
    port: number
    username: string
    password?: string
    from_email: string
    from_name?: string
    security: string
    daily_limit: number
    sent_today: number
    created_at: string
}

export interface EmailCampaign {
    id: number
    name: string
    subject: string
    body_html: string
    status: string
    smtp_account_id?: number
    total_recipients: number
    sent_count: number
    created_at: string
}

export const smtpApi = {
    getAll: () => api.get<SMTPAccount[]>('/smtp'),
    create: (data: Omit<SMTPAccount, 'id' | 'sent_today' | 'created_at'>) => api.post<SMTPAccount>('/smtp', data),
    update: (id: number, data: Partial<SMTPAccount>) => api.patch<SMTPAccount>(`/smtp/${id}`, data),
    delete: (id: number) => api.delete(`/smtp/${id}`),
    test: (id: number, email_to: string) => api.post(`/smtp/${id}/test`, { email_to })
}

export const emailCampaignsApi = {
    getAll: (skip = 0, limit = 20) => api.get<EmailCampaign[]>(`/email-campaigns?skip=${skip}&limit=${limit}`),
    create: (data: {
        name: string,
        subject: string,
        body_html: string,
        smtp_account_id?: number,
        recipients: string[]
    }) => api.post<EmailCampaign>('/email-campaigns', data),
    get: (id: number) => api.get<EmailCampaign>(`/email-campaigns/${id}`),
    update: (id: number, data: {
        name?: string,
        subject?: string,
        body_html?: string,
        smtp_account_id?: number,
        recipients?: string[]
    }) => api.patch<EmailCampaign>(`/email-campaigns/${id}`, data),
    delete: (id: number) => api.delete(`/email-campaigns/${id}`),
    start: (id: number) => api.post(`/email-campaigns/${id}/start`),
    resend: (id: number) => api.post(`/email-campaigns/${id}/resend`)
}

